import React from "react";
import { Space, Checkbox } from "antd";
import { DoubleRightOutlined } from "@ant-design/icons";
import { IoLayersOutline, IoLogoDropbox } from "react-icons/io5";

import * as S from "./styles";
import designSystemColors from "../../../../../styles";
import useAntecipateSalesModal from "./useAntecipateSalesModal";
import { TAntecipateSalesModal, TElegibleAntecipation } from "./types";
import SelectedSale from "../SelectedSale";
import { useClient } from "../../../../../hooks/ClientProvider";
import LoadingElevaty from "../../../../../components/LoadingElevaty";
import ConfirmAntecipateSaleModal from "../ConfirmAntecipateSaleModal";

const AntecipateSalesModal: React.FC<TAntecipateSalesModal> = ({
  visible,
  onClose,
  forceUpdate,
  handleForceUpdate,
}) => {
  const { client } = useClient();
  const {
    salesAntecipateData,
    selectedSaleId,
    selectedSaleData,
    toggleSale,
    fetchingData,
    antecipatePartial,
    antecipateTotal,
    modalConfirmSales,
    type,
    setModalConfirmSales,
    handleAntecipatePartial,
    handleAntecipateSaleTotal,
    loading,
    formatDate,
    installmentsToAntecipate,
    setInstallmentsToAntecipate,
  } = useAntecipateSalesModal({
    clientID: client?.client?.id,
    isVisible: visible,
    forceUpdate,
    handleForceUpdate,
    onClose,
  });

  return (
    <S.AntModal
      open={visible}
      onCancel={onClose}
      footer={null}
      width={800}
      data-test-id="modal-antecipar-vendas"
    >
      <Space style={{ marginBottom: 16 }}>
        <DoubleRightOutlined
          style={{ color: designSystemColors.generalButtons }}
        />
        <S.ModalTitle>Antecipação de Vendas</S.ModalTitle>
      </Space>

      {fetchingData ? (
        <S.LoadingWrapper>
          <LoadingElevaty />
          <S.LoadingText>
            Carregando as informações sobre antecipação de venda. Pode levar
            algum tempo.
          </S.LoadingText>
        </S.LoadingWrapper>
      ) : (
        <>
          {" "}
          {salesAntecipateData.length === 0 ? (
            <>
              <S.EmptyData>
                <S.EmptyDataText>
                  Sem vendas disponíveis para antecipar
                </S.EmptyDataText>
                <IoLogoDropbox
                  style={{ color: designSystemColors.textDark }}
                  size={24}
                />
              </S.EmptyData>
            </>
          ) : (
            <>
              <S.Description>
                Selecione as vendas para realizar a antecipação de parcelas.
              </S.Description>
              <S.SalesListContainer>
                <S.SectionTitle>
                  Selecione a venda para antecipar:
                </S.SectionTitle>
                {salesAntecipateData.map((sale) => (
                  <S.SaleCard
                    key={sale.idCompra}
                    isSelected={selectedSaleId === sale.idCompra}
                    onClick={() => toggleSale(sale.idCompra)}
                    data-test-id="card-selecionar-venda"
                  >
                    <S.StyledCheckbox
                      data-test-id="checkbox-selecionar-venda"
                      checked={selectedSaleId === sale.idCompra}
                    />
                    <S.SaleInfo>
                      <S.SalesNameInfo>
                        {sale.nomeEstabelecimento} -{" "}
                        {sale?.numeroParcelas -
                          sale?.numeroParcelasAntecipaveis}
                        /{sale?.numeroParcelas}
                      </S.SalesNameInfo>
                      <S.SalesDetailInfo>
                        {sale.nomeEstabelecimento} -{" "}
                        {formatDate(sale.dataCompra)}
                      </S.SalesDetailInfo>
                    </S.SaleInfo>
                    <S.SaleValue>R$ {sale?.valorTotalCompra}</S.SaleValue>
                  </S.SaleCard>
                ))}
              </S.SalesListContainer>
              {selectedSaleData ? (
                <SelectedSale
                  selectedSaleData={selectedSaleData}
                  antecipatePartial={antecipatePartial}
                  antecipateTotal={antecipateTotal}
                  formatDate={formatDate}
                  installmentsValue={installmentsToAntecipate}
                  onInstallmentsChange={setInstallmentsToAntecipate}
                />
              ) : (
                <S.EmptyState>
                  <IoLayersOutline
                    style={{ color: designSystemColors.grayChart }}
                  />
                  <S.EmptyStateText>
                    Selecione uma venda acima para visualizar os detalhes
                  </S.EmptyStateText>
                </S.EmptyState>
              )}
            </>
          )}
        </>
      )}

      <ConfirmAntecipateSaleModal
        visible={modalConfirmSales}
        type={type}
        idVenda={Number(selectedSaleId)}
        onClose={() => setModalConfirmSales(false)}
        antecipatePartial={handleAntecipatePartial}
        antecipateTotal={handleAntecipateSaleTotal}
        numeroParcela={installmentsToAntecipate}
        loading={loading}
        selectedSaleData={selectedSaleData as TElegibleAntecipation}
      />
    </S.AntModal>
  );
};

export default AntecipateSalesModal;
